import { CircularProgress, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const CircularLoader = ({ size, minHeight = '5rem', label = '' }) => {
    return (
        <Stack alignItems="center" justifyContent="center" sx={{ height: '100%', minHeight: minHeight }}>
            <CircularProgress size={size} />
            {label && (
                <Typography variant="body2" sx={{ mt: 2 }}>
                    Loading {label}...
                </Typography>
            )}
        </Stack>
    );
};

CircularLoader.propTypes = {
    size: PropTypes.number,
    minHeight: PropTypes.string,
    label: PropTypes.string
};

export default CircularLoader;
